/*
  Intl.NumberFormat can round numbers between -1 and 0 down to "0", but still
  show a negative sign in it because the original value was negative (e.g.
  "-0.00" when rounding -0.001 etc.) depending on how many decimals are
  involved. This shaves the minus character off the string in that scenario.
*/

var checkForNegativeZero = formattedValue => {
  /* if formattedValue is exactly "-0", "-$0", "-0%" then we can stop now, and
  return everything without minus sign */
  if (formattedValue === '-0' || formattedValue === '-$0' || formattedValue === '-0%') return formattedValue.replace('-', '');

  /* but the string could still be something like "-0.00%" or "-$0.00" depending
  on props, so split on decimal point in order to check each side */
  var [integerSide, decimalSide] = formattedValue.split('.');

  /* if the integer side is "-$0" or "-0", and every character on decimal side
  is "0" or "%" then this means we can return everything without the minus sign
  */
  if ((integerSide === '-$0' || integerSide === '-0') && Array.from(decimalSide).every(char => char === '0' || char === '%')) return "".concat(integerSide.replace('-', ''), ".").concat(decimalSide);

  // else return the unmutated formattedValue
  return formattedValue;
};
export default checkForNegativeZero;